import styles from './styles.module.css';

interface StatusIndicatorProps<T extends { status?: string }> {
  location: T;
}

const StatusIndicator = <T extends { status?: string }>({
  location
}: StatusIndicatorProps<T>) => {
  const getStatus = (location: T) => {
    if (location.status === 'Active') {
      return { text: 'Active', color: 'var(--color-green)' };
    } else {
      return { text: 'Inactive', color: 'var(--color-orange)' };
    }
  };

  const status = getStatus(location);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{status?.text}</span>
      <div
        className={styles.statusIndicator}
        style={{ backgroundColor: status?.color }}
      />
    </div>
  );
};

export default StatusIndicator;
